import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0f4ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 md:col-12 grid justify-content-end" }
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = { class: "mr-2" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "p-fluid grid",
  style: {"height":"100%"}
}
const _hoisted_6 = {
  class: "col-12 md:col-3",
  style: {"height":"100%"}
}
const _hoisted_7 = {
  key: 0,
  class: "flex mb-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "assina-depois",
  class: "ml-2"
}, " Criar CI para o secretário assinar ", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Qual o tipo da CI ?")
], -1))
const _hoisted_11 = { class: "grid m-0 p-2 mb-3" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "De qual setor você deseja enviar a CI ?")
], -1))
const _hoisted_15 = { class: "col-12 m-0 p-2" }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Por qual secretaria deseja enviar?")
], -1))
const _hoisted_18 = { class: "col-12 m-0 p-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Para quem deseja enviar ?")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "grid m-0 p-2 mb-3"
}
const _hoisted_21 = ["for"]
const _hoisted_22 = {
  key: 0,
  class: "col-12 m-0 p-2"
}
const _hoisted_23 = {
  key: 1,
  class: "col-12 m-0 p-2"
}
const _hoisted_24 = {
  key: 2,
  class: "col-12 m-0 p-2"
}
const _hoisted_25 = {
  class: "col-12 md:col-7",
  style: {"height":"100%"}
}
const _hoisted_26 = {
  key: 0,
  class: "grid"
}
const _hoisted_27 = { class: "col-12 md:col-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Selecione o mês referente à CI:", -1))
const _hoisted_29 = { class: "col-12 md:col-6" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Coloque o dia referente à CI :", -1))
const _hoisted_32 = { class: "col-12 md:col-12 p-0" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Assunto:", -1))
const _hoisted_35 = { class: "p-error flex justify-content-center span" }
const _hoisted_36 = { class: "col-12 md:col-12 mt-1 p-0" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Se desejar, defina um prazo limite para resposta:", -1))
const _hoisted_39 = { class: "col-12 md:col-12 mt-2 p-0" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "Digite o texto da sua solicitação: ", -1))
const _hoisted_41 = { class: "p-error flex justify-content-center span" }
const _hoisted_42 = {
  style: {"display":"none !important"},
  class: "field col-12 md:col-12 flex align-items-center"
}
const _hoisted_43 = { class: "p-input-filled md:col-11 p-0" }
const _hoisted_44 = {
  class: "col-12 md:col-2",
  style: {"height":"100%"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Anexos da CI")
], -1))
const _hoisted_46 = { class: "mt-1" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-paperclip mr-2",
  style: {"font-size":"14px"}
}, null, -1))
const _hoisted_48 = { class: "grid p-0 m-0 justify-content-center align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-12 flex justify-content-center" }, "Senha da Assinatura:", -1))
const _hoisted_50 = { class: "col-12 flex justify-content-center" }
const _hoisted_51 = {
  key: 0,
  style: {"color":"#f00"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pm_Button = _resolveComponent("pm-Button")!
  const _component_pm_Message = _resolveComponent("pm-Message")!
  const _component_pm_Checkbox = _resolveComponent("pm-Checkbox")!
  const _component_pm_RadioButton = _resolveComponent("pm-RadioButton")!
  const _component_pm_Dropdown = _resolveComponent("pm-Dropdown")!
  const _component_pm_MultiSelect = _resolveComponent("pm-MultiSelect")!
  const _component_pm_ScrollPanel = _resolveComponent("pm-ScrollPanel")!
  const _component_pm_InputText = _resolveComponent("pm-InputText")!
  const _component_pm_InputNumber = _resolveComponent("pm-InputNumber")!
  const _component_tinyMce = _resolveComponent("tinyMce")!
  const _component_pm_FileUpload = _resolveComponent("pm-FileUpload")!
  const _component_pm_Chip = _resolveComponent("pm-Chip")!
  const _component_Form = _resolveComponent("Form")!
  const _component_pm_Dialog = _resolveComponent("pm-Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_pm_Dialog, {
    visible: _ctx.displayPosition,
    "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.displayPosition) = $event)),
    header: "Nova Comunicação Interna",
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: {
      width: '100% !important',
      height: '100vh',
    },
    modal: true,
    class: "p-dialog-maximized"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.loadingButton)
            ? _withDirectives((_openBlock(), _createBlock(_component_pm_Button, {
                key: 0,
                label: "Aguarde",
                class: "p-button-info",
                icon: "fas fa-file-pdf",
                iconPos: "right",
                disabled: ""
              }, null, 512)), [
                [
                  _directive_tooltip,
                  'Visualizar a CI antes de ser enviada',
                  void 0,
                  { top: true }
                ]
              ])
            : _withDirectives((_openBlock(), _createBlock(_component_pm_Button, {
                key: 1,
                label: "Visualizar",
                class: "p-button-info",
                icon: "fas fa-file-pdf",
                iconPos: "right",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gerarPdf(_ctx.mensagem)))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  'Visualizar a CI antes de ser enviada',
                  void 0,
                  { top: true }
                ]
              ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (
            _ctx.modo == 'nova' &&
            _ctx.loadingButton &&
            (!_ctx.flagAssinarDepois || !_ctx.permissoes.hab_escrever_ci_para_assinar)
          )
            ? _withDirectives((_openBlock(), _createBlock(_component_pm_Button, {
                key: 0,
                label: "Aguarde",
                class: "p-button-info",
                icon: "fas fa-floppy-disk",
                iconPos: "right",
                disabled: ""
              }, null, 512)), [
                [
                  _directive_tooltip,
                  'Salvar C.I para ser assinada e enviada depois',
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true),
          (
            _ctx.modo == 'nova' &&
            !_ctx.loadingButton &&
            (!_ctx.flagAssinarDepois || !_ctx.permissoes.hab_escrever_ci_para_assinar)
          )
            ? _withDirectives((_openBlock(), _createBlock(_component_pm_Button, {
                key: 1,
                label: "Salvar",
                class: "p-button-info",
                icon: "fas fa-floppy-disk",
                iconPos: "right",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enviaMensagem(1)))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  'Salvar C.I para ser assinada e enviada depois',
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (
            _ctx.modo == 'nova' &&
            _ctx.loadingButton === true &&
            _ctx.permissoes.hab_escrever_ci_para_assinar &&
            _ctx.flagAssinarDepois
          )
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 0,
                class: "p-button-success",
                icon: "fas fa-share",
                label: "Aguarde",
                iconPos: "right",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enviaMensagem(1))),
                disabled: ""
              }))
            : _createCommentVNode("", true),
          (
            _ctx.modo == 'nova' &&
            _ctx.permissoes.hab_escrever_ci_para_assinar &&
            _ctx.flagAssinarDepois &&
            _ctx.loadingButton == false
          )
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 1,
                class: "p-button-success",
                icon: "fas fa-share",
                label: "Enviar",
                iconPos: "right",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enviaMensagem(1)))
              }))
            : _createCommentVNode("", true),
          (
            _ctx.modo == 'nova' &&
            _ctx.loadingButton &&
            (!_ctx.flagAssinarDepois || !_ctx.permissoes.hab_escrever_ci_para_assinar)
          )
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 2,
                disabled: "",
                label: "Aguarde",
                class: "p-button-success",
                icon: "fas fa-share",
                iconPos: "right",
                onClick: _ctx.enviaMensagem
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (
            _ctx.modo == 'nova' &&
            !_ctx.loadingButton &&
            (!_ctx.flagAssinarDepois || !_ctx.permissoes.hab_escrever_ci_para_assinar)
          )
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 3,
                label: "Assinar",
                class: "p-button-success",
                icon: "fas fa-share",
                iconPos: "right",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalAssinatura = true))
              }))
            : _createCommentVNode("", true),
          (_ctx.modo == 'edicao' && _ctx.loadingButton)
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 4,
                disabled: "",
                label: "Aguarde",
                class: "p-button-success mr-3 col-1",
                icon: "fas fa-share",
                iconPos: "right",
                onClick: _ctx.editar
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.modo == 'edicao' && !_ctx.loadingButton)
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 5,
                label: "Editar",
                class: "p-button-success mr-3 col-1",
                icon: "fas fa-share",
                iconPos: "right",
                onClick: _ctx.editar
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.mensagemAviso != '')
        ? (_openBlock(), _createBlock(_component_pm_Message, {
            key: 0,
            severity: "warn",
            life: 10000,
            sticky: false,
            class: "col-3 mb-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.mensagemAviso), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, { style: {"height":"83vh"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_pm_ScrollPanel, {
                style: {"width":"100%","height":"100%"},
                class: "custombar1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (
                  _ctx.permissoes.hab_escrever_ci_para_assinar &&
                  _ctx.mensagem.cadastro_usuario_id == 0
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_pm_Checkbox, {
                            modelValue: _ctx.flagAssinarDepois,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.flagAssinarDepois) = $event)),
                            binary: true,
                            inputId: "assina-depois",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trocaVisualizacaoPermissao()))
                          }, null, 8, ["modelValue"]),
                          _hoisted_8
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.permissoes.hab_envio_reservado)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipoCi, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "mr-3",
                                key: item.id
                              }, [
                                _createVNode(_component_pm_RadioButton, {
                                  value: item.id,
                                  modelValue: _ctx.selecionarTipoCi,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selecionarTipoCi) = $event)),
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.zeraBotoes()))
                                }, null, 8, ["value", "modelValue"]),
                                _createElementVNode("span", {
                                  class: "ml-2",
                                  for: item.id
                                }, _toDisplayString(item.nome), 9, _hoisted_12)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.usuario.setores.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_pm_Dropdown, {
                              optionLabel: "setor.nome",
                              options: _ctx.usuario.vinculos,
                              modelValue: _ctx.qualSetorEnviar,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.qualSetorEnviar) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selecionarTipoCi === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_pm_Dropdown, {
                              class: "mr-2",
                              optionLabel: "nome",
                              options: _ctx.todasSecs,
                              modelValue: _ctx.porQualSecEnviar,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.porQualSecEnviar) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _hoisted_19,
                      (_ctx.selecionarTipoCi === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipoSecOuSet, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "mr-3",
                                key: item.id
                              }, [
                                _createVNode(_component_pm_RadioButton, {
                                  value: item.id,
                                  onChange: _ctx.procurarSec,
                                  modelValue: _ctx.selecionarSecOuSet,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selecionarSecOuSet) = $event))
                                }, null, 8, ["value", "onChange", "modelValue"]),
                                _createElementVNode("span", {
                                  class: "ml-2",
                                  for: item.id
                                }, _toDisplayString(item.nome), 9, _hoisted_21)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (
                _ctx.ehSecretario &&
                !_ctx.mostrarApenasOsSetores &&
                !_ctx.permissoes.hab_envio_reservado
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_pm_MultiSelect, {
                          options: _ctx.secFiltrado,
                          optionLabel: "nome",
                          class: "mr-2",
                          placeholder: "Selecione a secretaria ou o setor",
                          modelValue: _ctx.secSelec,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.secSelec) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (
                (_ctx.mostrarApenasOsSetores || !_ctx.ehSecretario) &&
                _ctx.selecionarTipoCi === 1
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_pm_MultiSelect, {
                          options: _ctx.secFiltrado,
                          optionLabel: "nome",
                          class: "mr-2",
                          placeholder: "Selecione a secretaria ou o setor",
                          modelValue: _ctx.secSelec,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.secSelec) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (
                (_ctx.mostrarApenasOsSetores || !_ctx.ehSecretario) &&
                _ctx.selecionarTipoCi === 2
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_pm_MultiSelect, {
                          options: _ctx.todasSecs,
                          optionLabel: "nome",
                          class: "mr-2",
                          placeholder: "Selecione a secretaria",
                          modelValue: _ctx.secSelec,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.secSelec) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_pm_ScrollPanel, {
                style: {"width":"100%","height":"100%"},
                class: "custombar1"
              }, {
                default: _withCtx(() => [
                  (_ctx.permissoes.hab_envio_reservado && _ctx.selecionarTipoCi === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", null, [
                            _hoisted_28,
                            _createVNode(_component_pm_Dropdown, {
                              options: _ctx.periodos,
                              modelValue: _ctx.periodo,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.periodo) = $event))
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, [
                            _hoisted_31,
                            _createVNode(_component_pm_InputText, {
                              type: "number",
                              min: "0",
                              max: "31",
                              id: "assunto",
                              name: "titulo",
                              onKeyup: _ctx.isValid,
                              modelValue: _ctx.selectDay,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectDay) = $event))
                            }, null, 8, ["onKeyup", "modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_pm_InputText, {
                        id: "assunto",
                        type: "text",
                        name: "titulo",
                        modelValue: _ctx.mensagem.titulo,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mensagem.titulo) = $event)),
                        class: _normalizeClass({ 'p-invalid': _ctx.errors.titulo != '' }),
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validate('titulo'))),
                        onKeypress: _cache[19] || (_cache[19] = ($event: any) => (_ctx.validate('titulo')))
                      }, null, 8, ["modelValue", "class"]),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.errors.titulo), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_pm_InputNumber, {
                        id: "prazo_resposta",
                        type: "text",
                        name: "prazo_resposta",
                        modelValue: _ctx.mensagem.prazo_resposta,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mensagem.prazo_resposta) = $event)),
                        min: 0
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(_component_tinyMce, {
                      modelValue: _ctx.mensagem.conteudo,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mensagem.conteudo) = $event)),
                      onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validate('conteudo'))),
                      onKeypress: _cache[23] || (_cache[23] = ($event: any) => (_ctx.validate('conteudo')))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.errors.conteudo), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, [
                _createVNode(_component_pm_InputText, {
                  placeholder: "Id de Mensagem Referência (001/2020)",
                  id: "referencia",
                  type: "text",
                  name: "referencia",
                  modelValue: _ctx.mensagem.referencia_id,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.mensagem.referencia_id) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_pm_ScrollPanel, {
                style: {"width":"100%","height":"100%"},
                class: "custombar1"
              }, {
                default: _withCtx(() => [
                  _hoisted_45,
                  _createElementVNode("div", null, [
                    _createVNode(_component_pm_FileUpload, {
                      style: {"width":"100%"},
                      class: "p-fileupload",
                      uploadIcon: "fas fa-paperclip",
                      mode: "basic",
                      auto: true,
                      name: "nota[]",
                      url: null,
                      id: "input",
                      chooseLabel: "Anexar",
                      customUpload: true,
                      onUploader: _ctx.processaArquivos,
                      uploadLabel: "Enviar Anexos",
                      cancelLabel: "Cancelar",
                      multiple: true
                    }, null, 8, ["onUploader"]),
                    (_ctx.errosAnexo.length > 0)
                      ? (_openBlock(), _createBlock(_component_pm_Message, {
                          key: 0,
                          severity: "error"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errosAnexo, (i) => {
                              return (_openBlock(), _createElementBlock("p", {
                                style: {"color":"#f00"},
                                key: i
                              }, _toDisplayString(i), 1))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mensagem.anexos, (d) => {
                      return (_openBlock(), _createElementBlock("span", { key: d }, [
                        _createVNode(_component_pm_Chip, {
                          label: d.nome_arquivo,
                          class: "mr-2",
                          removable: true,
                          onRemove: ($event: any) => (_ctx.removerAnexo(d.id)),
                          style: {"margin-top":"8px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _hoisted_47,
                              _createElementVNode("span", null, _toDisplayString(d.nome_arquivo), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "onRemove"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_pm_Dialog, {
        visible: _ctx.modalAssinatura,
        "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.modalAssinatura) = $event)),
        modal: "",
        breakpoints: { '960px': '75vw', '641px': '100vw' },
        header: "Assinar"
      }, {
        footer: _withCtx(() => [
          (_ctx.loadingButton === true)
            ? (_openBlock(), _createBlock(_component_pm_Button, {
                key: 0,
                class: "p-button-sm",
                label: "Aguarde",
                autofocus: "",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.enviaMensagem(2))),
                disabled: ""
              }))
            : (_openBlock(), _createBlock(_component_pm_Button, {
                key: 1,
                class: "p-button-sm",
                label: "Assinar e Enviar",
                autofocus: "",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.enviaMensagem(2)))
              }))
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_pm_InputText, {
                class: _normalizeClass(["col-5", _ctx.errorColor]),
                modelValue: _ctx.senhaSig,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.senhaSig) = $event)),
                type: "password"
              }, null, 8, ["modelValue", "class"])
            ]),
            _createElementVNode("div", null, [
              (!_ctx.flagAssina)
                ? (_openBlock(), _createElementBlock("small", _hoisted_51, _toDisplayString(_ctx.passwordFailed), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["visible"]))
}